import { c as _c } from "react/compiler-runtime";
import type { CommunityMemberMinimal } from "@/entities/IProfile";
import GroupCreateIdentitiesSearchItem from "./GroupCreateIdentitiesSearchItem";
export default function GroupCreateIdentitiesSearchItemsContent(t0) {
  const $ = _c(11);
  const {
    selectedWallets,
    loading,
    items,
    onSelect
  } = t0;
  if (loading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <li className="tw-py-2 tw-w-full tw-h-full tw-flex tw-items-center tw-justify-between tw-text-sm tw-font-medium tw-text-white tw-rounded-lg tw-relative tw-select-none tw-px-2">Loading...</li>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (items.length) {
    let t1;
    if ($[1] !== items || $[2] !== onSelect || $[3] !== selectedWallets) {
      let t2;
      if ($[5] !== onSelect || $[6] !== selectedWallets) {
        t2 = item => <GroupCreateIdentitiesSearchItem key={item.wallet} item={item} selected={selectedWallets.includes(item.wallet)} onProfileSelect={onSelect} />;
        $[5] = onSelect;
        $[6] = selectedWallets;
        $[7] = t2;
      } else {
        t2 = $[7];
      }
      t1 = items.map(t2);
      $[1] = items;
      $[2] = onSelect;
      $[3] = selectedWallets;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    let t2;
    if ($[8] !== t1) {
      t2 = <>{t1}</>;
      $[8] = t1;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    return t2;
  }
  let t1;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <li className="tw-py-2 tw-w-full tw-h-full tw-flex tw-items-center tw-justify-between tw-text-sm tw-font-medium tw-text-white tw-rounded-lg tw-relative tw-select-none tw-px-2">No results</li>;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  return t1;
}